import { apiGet, apiPost } from "./client";

export function getWithdrawOptions() {
  return apiGet("/withdraw-options");
}

export function requestWithdraw(payload) {
  return apiPost("/withdraw", payload);
}

export function getWithdraws() {
  return apiGet("/withdraws");
}
